<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header routeId="import"></frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <div *ngIf="location">
    <nav aria-label="breadcrumb" role="navigation">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/reservations']">{{location.displayOptions.labels.reservation_plural | titlecase}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Import from CSV</li>
      </ol>
    </nav>

    <tablesready-import-form
      [hidden]="parties.length > 0"
      [location]="location"
      (onImportedData)="onData($event)"
    ></tablesready-import-form>
    <tablesready-import-list
      *ngIf="parties.length"
      [location]="location"
      [parties]="parties"
      (onCancel)="onData($event)"
    ></tablesready-import-list>
  </div>
</ion-content>
